import { IconBrain, IconBulb, IconTarget, IconBolt, IconShield, IconBook } from "@tabler/icons-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: IconBrain,
      titleKey: "features.list.defaultLock.title",
      descriptionKey: "features.list.defaultLock.description"
    },
    {
      icon: IconBolt,
      titleKey: "features.list.focusTime.title",
      descriptionKey: "features.list.focusTime.description"
    },
    {
      icon: IconBulb,
      titleKey: "features.list.unlockModes.title",
      descriptionKey: "features.list.unlockModes.description"
    },
    {
      icon: IconShield,
      titleKey: "features.list.strictMode.title",
      descriptionKey: "features.list.strictMode.description"
    },
    {
      icon: IconBook,
      titleKey: "features.list.preventContinuousUnlock.title",
      descriptionKey: "features.list.preventContinuousUnlock.description"
    },
    {
      icon: IconTarget,
      titleKey: "features.list.freeze.title",
      descriptionKey: "features.list.freeze.description"
    },
  ];

  return (
    <section className="py-6 md:py-8 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-4 md:mb-6">
            {t('features.title')}
          </h2>
          <p className="text-left text-slate-600 leading-relaxed text-base md:text-lg mb-6 mx-2">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 pb-8 md:p-8 rounded-2xl bg-white border border-slate-200"
            >
              <div className="mb-4">
                <div className={cn(
                  "w-10 h-10 md:w-14 md:h-14 rounded-full flex items-center justify-center group-hover:md:scale-105 transition-transform duration-300",
                  index % 2 === 0
                    ? "bg-sky-500"
                    : "bg-teal-400"
                )}>
                  <feature.icon className="w-6 md:w-7 h-6 md:h-7 text-white" />
                </div>
              </div>
              <h3 className={cn(
                "text-lg md:text-xl font-semibold mb-3 group-hover:text-sky-500 transition-colors duration-300",
                index % 2 === 0
                  ? "text-sky-500 md:text-slate-900"
                  : "text-teal-500 md:text-slate-900"
              )}>
                {t(feature.titleKey)}
              </h3>
              <p className="text-base md:text-base text-slate-600 leading-relaxed">
                {t(feature.descriptionKey)}
              </p>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
};

export default Features;
